import {ChangeDetectionStrategy, Component} from '@angular/core';
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {PageSubtitleComponent} from "../../../components/page-subtitle/page-subtitle.component";
import {ParagraphsComponent} from "../../../components/paragraphs/paragraphs.component";
import {TextPageComponent} from "../../../components/text-page/text-page.component";

@Component({
  selector: 'homey-terms-and-conditions-page',
  imports: [
    PageSubtitleComponent,
    PageTitleComponent,
    ParagraphsComponent,
    TextPageComponent
  ],
  templateUrl: './terms-and-conditions-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsAndConditionsPageComponent {

}
